/// <reference types="vite/client" />
import { createClient } from "@supabase/supabase-js";
import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";
import { prepareSandbox } from "./sandbox";

declare global {
  interface ImportMetaEnv {
    readonly VITE_SUPABASE_URL: string;
    readonly VITE_SUPABASE_ANON_KEY: string;
    readonly VITE_SANDBOX_RUN?: string;
  }

  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

const env: ImportMetaEnv = import.meta.env;
const url: string = env.VITE_SUPABASE_URL;
const anonKey: string = env.VITE_SUPABASE_ANON_KEY;
prepareSandbox(env.MODE, url, env.VITE_SANDBOX_RUN);
if (!url || !anonKey) {
  throw new Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in .env.local");
}

export const supabase: SupabaseClient<Database> = createClient<Database>(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
